import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AdministrationService } from '../../service';
import { ConfirmationService, MessageService } from 'primeng/api';
import moment from 'moment';
import { Settings } from '../../lib/app.constant';
import { AppMainComponent } from '../main-panel/app.main.component';
import { Router } from '@angular/router';


@Component({
  selector: 'app-sidebar-filter',
  templateUrl: './sidebar-filter.component.html',
  styleUrls: ['./sidebar-filter.component.scss']
})
export class SidebarFilterComponent {
  @Input() grid_schema: any[] = [];
  @Input() filterModel: any;
  @Input() documentFieldList = [];
  @Input() showFilterTemplate: boolean = false;
  @Input() showSaveFilterTemplate: boolean = false;
  @Input() showDeleteTemplate: boolean = false;
  @Input() showFilter!: boolean;
  @Input() module_id: any;
  @Output() toggleFilter = new EventEmitter<void>();
  @Output() closeSidebar = new EventEmitter<void>();
  @Output() applyFilter = new EventEmitter<void>();
  @Output() resetFilter = new EventEmitter<void>();
  @Output() dateSelectFilter = new EventEmitter<{ event: any, colKey: string }>();
  @Output() populateFilter = new EventEmitter<{ event: any }>();
  @Output() clearFilterModel = new EventEmitter<{ event: any }>();
  saveTemplateForm = new FormGroup({
    is_shared: new FormControl(false, [Validators.required]),
    template_name: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(30)]),
  })
  templateData = null;
  showUpdate: any;
  template_id: any;
  templateList: any;
  template_data: any;
  isDeleting: boolean;
  previousSelectedTemplate: any;

  constructor(public router: Router,public appMain: AppMainComponent, public confirmationService: ConfirmationService, public adminService: AdministrationService, public messageService: MessageService) {

  }

  ngOnInit() {
    // if(window.location.href.includes('search/document-grid')){
    //  this.getAllFilterTemplates();
    // }
    
    this.appMain.configActive = false;
  }

  toggleFilterPanel() {
    this.toggleFilter.emit();
  }

  closeFilterSidebar() {
    this.closeSidebar.emit();
  }

  applyFilterSidebar() {
    this.applyFilter.emit();
  }

  restFilterSidebar() {
    this.templateData = null;
    this.onChangeGetFilterTemplateDetails({ value: this.templateData })
    this.resetFilter.emit();
  }

  onDateSelect(event, colKey) {
    this.dateSelectFilter.emit({ event, colKey });
  }

  onClickSaveTemplate() {
    let selectedClientId = JSON.parse(localStorage.getItem('selectedClientId'));
    let body = {
      "id": this.showUpdate ? this.template_id : 0,
      "preference_type": this.module_id,
      "user_preference_setting": this.filterModel,
      "application_id": selectedClientId,
      "template_name": this.saveTemplateForm.value.template_name,
      "is_shared": this.saveTemplateForm.value.is_shared
    }
    this.adminService.saveFilterTemplate(body).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Filter Template Added',
          detail: 'New Filter Template has been added successfully.'
        });
        this.getAllFilterTemplates();
        this.saveTemplateForm.controls['is_shared'].setValue(false);
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Occurred',
          detail: error?.error?.message ?? 'Failed to Add New Filter Template'
        });
        this.saveTemplateForm.controls['is_shared'].setValue(false);
      }
    })
  }

  onDataElementDateSelect(event, key) {
    const formattedDate = moment(event).format(Settings.DateFormats.dateFormatOnlyDate);
    this.filterModel.data_elements[key] = formattedDate;
  }

  getAllFilterTemplates() {
    let selectedClientId = JSON.parse(localStorage.getItem('selectedClientId'));
    let body = {
      "preference_type": this.module_id,
      "application_id": selectedClientId
    }
    this.adminService.getFilterTemplateList(body).subscribe({
      next: (res: any) => {
        let transformedData = [
          {
            name: 'Private',
            items: res.private_templates?.map((template: any) => ({
              id: template.id,
              template_name: template.template_name,
              user_preference_setting: template?.user_preference_setting,
              is_shared: false
            }))
          },
          {
            name: 'Public',
            items: res.public_templates?.map((template: any) => ({
              id: template.id,
              template_name: template.template_name,
              user_preference_setting: template?.user_preference_setting,
              is_shared: true
            }))
          }
        ];
        this.templateList = transformedData;
      },
      error: (error: any) => {
        this.templateList = [];
        this.messageService.add({
          severity: 'error',
          summary: 'Error Occurred',
          detail: error?.error?.message ?? 'Something Went Wrong , Please Try Again Later'
        });
      }
    })
  }

  onChangeGetFilterTemplateDetails(event) {
    if (!this.isDeleting) {
      if (event?.value) {
        this.previousSelectedTemplate = event?.value;
        let data = event?.value;
        this.showUpdate = true;
        this.template_id = data?.id;
        try {
          const preprocessedString = data?.user_preference_setting
            .replace(/'/g, '"')
            .replace(/None/g, 'null')
            .replace(/False/g, 'false')
            .replace(/True/g, 'true');
          this.template_data = JSON.parse(preprocessedString);
        } catch (error) {
          this.template_data = data?.user_preference_setting;
        }
        this.populateFilterTemplateData(this.template_data);
        this.saveTemplateForm.patchValue({
          is_shared: data?.is_shared,
          template_name: data?.template_name
        })
      } else {
        this.showUpdate = false;
        this.template_id = 0;
        this.templateData = this.previousSelectedTemplate = null;
        this.saveTemplateForm.reset();
        this.clearFilterModel.emit();
      }
    } else {
      setTimeout(() => {
        this.templateData = null;
      }, 100);
    }
  }

  populateFilterTemplateData(data) {
    this.populateFilter.emit({ event: data });
  }

  onClickDeleteTemplate(templateId) {
    this.isDeleting = true;
    this.templateData = null;
    this.confirmationService.confirm({
      message: 'Are you sure, you want to Delete this Template ?',
      accept: () => {
        this.adminService.deleteFilterTemplateById(templateId).subscribe({
          next: (res: any) => {
            this.getAllFilterTemplates();
            this.isDeleting = false;
          },
          error: (error: any) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error Occurred',
              detail: 'Something Went Wrong , Please Try Again Later'
            });
            this.isDeleting = false;
          }
        }
        );
      },
      reject: () => {
        this.isDeleting = false;
        this.templateData = this.previousSelectedTemplate;
      }
    });
  }

  hasFilterValues(): boolean {
    if (!this.filterModel) {
      return false;
    }
    return Object.values(this.filterModel).some(value => {
      if (value == null) {
        return false;
      }
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      if (typeof value === 'object') {
        return Object.values(value).some(val => val != null && val !== '');
      }
      return value !== '';
    });
  }

}
